export default "__VITE_ASSET__Chge7pgV__"